import { 
// eslint-disable-next-line no-unused-vars
ContactChannels, ConversationItemTypeEnum, ConversationMediaType, ConversationStatusType, MessageInboundState, MessageOutboundState } from '@/types/ConversationTypes';
import { AgentStatus, AuthorType } from '@/types/UserTypes';
import { CardItemType } from '@/types/CardTypes';
import API from "@/services/api";
import { LocaleTypes, Views } from "@/types/ConfigTypes";
import { ElementDataType, ElementType, FormTypes } from "@/types/FormTypes";
export const AGENT_1 = {
    avatarUrl: 'https://static.intercomassets.com/avatars/3356436/square_128/IMG_9774-1565898438.JPG?1565898438',
    name: 'Clarice Starling',
    nick: 'Clarice',
    status: AgentStatus.ONLINE,
    isTyping: false
};
export const AGENT_2 = {
    avatarUrl: 'https://static.intercomassets.com/avatars/5240383/square_128/IMG_0551_%281%29-1634738499.jpeg?1634738499',
    name: 'Sandra',
    status: AgentStatus.ONLINE,
    isTyping: false
};
export const AGENT_1_ONLINE = {
    avatarUrl: 'https://static.intercomassets.com/avatars/3356436/square_128/IMG_9774-1565898438.JPG?1565898438',
    name: 'Clarice',
    nick: 'ClariceNick',
    status: AgentStatus.ONLINE,
    isTyping: false
};
export const BOT = {};
export const SYSTEM = {};
export const CUSTOMER = {
    name: 'You'
};
/* Receiving conversation elements such as messages, agent status updates */
export const INBOUND_MSGS = [
    {
        "type": "message.new",
        "conversations": [{
                "id": 1234567890,
                "caseId": "ABC-12345",
                "items": [{
                        "id": 8534983092123893,
                        "type": ConversationItemTypeEnum.MESSAGE,
                        "authorType": AuthorType.AGENT,
                        "author": AGENT_1,
                        "body": "Message from the agent [" + Math.random() + "]",
                        "ts": 1639660443
                    }]
            }],
    },
    {
        "type": "conversation.end",
        "id": 1234567890
    },
    {
        "type": "agent.update",
        "agentsOnline": true,
        "agents": [
            AGENT_1, AGENT_2
        ]
    },
    {
        "type": "conversation.update",
        "id": 9876543210,
        "updated": {
            "agent": {
                "avatarUrl": "https://static.intercomassets.com/avatars/3356436/square_128/IMG_9774-1565898438.JPG?1565898438",
                "name": "Clarice",
                "status": AgentStatus.ONLINE,
                "isTyping": false
            }
        }
    },
    // agent is typing
    {
        "type": "conversation.update",
        "id": 1234567890,
        "updated": {
            "agent": {
                "isTyping": true
            }
        }
    }
];
const initResponse = {
    sessionData: {
        uid: "uid-06915b32-5d0c-4d5b-abe7-bc03a21ee885",
        sid: "sid-8b290ac7-6fd5-4a96-a203-68855ac4770e"
    },
    settings: {
        mergeFields: {
            companyName: 'Grasp'
        },
        locales: [
            LocaleTypes.NL,
            LocaleTypes.EN,
            LocaleTypes.AR
        ],
        localeMessages: {
            en: {
                home: {
                    title: "Hi There!",
                    text: "We are [[COMPANY_NAME]]. How can we help you today?"
                }
            },
            nl: {
                home: {
                    title: "Hallo!",
                },
                gdpr: {
                    header: 'GDPR new header'
                }
            }
        },
        defaultLocale: 'nl',
        appearance: {
            // primaryColor: '#da2b74',
            // primaryColor: '#de9023',
            primaryColor: '#6A57F5',
            // primaryColor: '#22a583',
            brandingEnabled: true,
            switchThemeEnabled: true,
            showPageSelectorFooter: true,
            showLanguageSelector: false,
            logoImageUrl: 'http://localhost:8080/assets/grasp-logo.png'
        },
        views: [{
                type: Views.HOME_SCREEN,
            }, {
                type: Views.LAST_CONVERSATION
            }, {
                type: Views.HELPCENTER
            }, {
                type: Views.MAILFORM
            }, {
                type: Views.WHATSAPP
            }],
        channels: [
            {
                type: 'WHATSAPP',
                props: {
                    phone: '31615402722'
                }
            }
        ],
        conversation: {
            prechatEnabled: true
        }
    },
    status: {
        emailAddressFound: true,
        agentsOnline: true
    },
    enabled: true
};
export const MOCK_DATA = [
    /** initialize messenger */
    {
        url: '/init',
        status: 200,
        data: {
            data: initResponse
        }
    },
    /** page view (basically the home screen for now  */
    {
        url: '/page/home',
        status: 200,
        data: {
            data: {
                title: 'Hi there!',
                text: 'We are Grasp and we help your business to make conversations count.',
                cards: [
                    {
                        type: CardItemType.AGENT_AVAILABILITY,
                    },
                    {
                        type: CardItemType.CONVERSATION_LIST,
                    },
                    {
                        type: CardItemType.HELP_CENTER_SEARCH_BAR,
                    },
                    {
                        type: CardItemType.START_NEW_CONVERSATION,
                    },
                    {
                        type: CardItemType.SEND_EMAIL_BUTTON,
                    },
                    {
                        type: CardItemType.ARTICLE_LIST,
                        data: {
                            articles: [
                                {
                                    id: 19302,
                                    title: 'Rebranding Grasp',
                                    updated: 1507942121,
                                    excerpt: 'We are getting our notebooks out to count all of our conversations. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in rhoncus justo. Maecenas mattis, ante ut sodales molestie, nunc quam pretium turpis, eget facilisis ipsum diam ut urna. Aliquam erat volutpat. Proin lacinia erat quis libero suscipit, in placerat ipsum congue. Nam porttitor eros in ante tristique, aliquet interdum ipsum mattis. Nullam ex dui, sodales vel purus in, vehicula maximus sapien. Suspendisse eget erat ac erat imperdiet sagittis.'
                                },
                                {
                                    id: 95439832,
                                    title: 'Personalizing site messenger',
                                    updated: 1639262184,
                                    excerpt: 'The site messenger allows you to custom the look and feel to your own liking. Not only the primary color can be changed, but the welcome text as well.'
                                }
                            ]
                        }
                    },
                    {
                        type: CardItemType.WHATSAPP_CONNECT,
                        data: {
                            phone: '31615402722'
                        }
                    },
                    {
                        type: CardItemType.CHANNEL_SELECTOR,
                        data: {
                            channels: [
                                {
                                    type: ContactChannels.WHATSAPP,
                                    options: {
                                        number: null
                                    }
                                },
                                {
                                    type: ContactChannels.EMAIL,
                                    options: {}
                                }
                            ]
                        }
                    },
                    {
                        type: CardItemType.MAIL_FORM,
                    },
                    {
                        type: CardItemType.WHATSAPP_CONTACT_FORM,
                    }
                ],
            }
        }
    },
    /** get conversation excerpts to view them in the home screen (last message only) */
    {
        url: '/conversations',
        status: 200,
        data: {
            data: {
                archivedCount: 1,
                conversations: [{
                        id: 1234567890,
                        caseId: 'ABC-12345',
                        agent: AGENT_2,
                        items: [{
                                id: 8534983092123893,
                                type: ConversationItemTypeEnum.MESSAGE,
                                status: ConversationStatusType.OPEN,
                                authorType: AuthorType.AGENT,
                                author: AGENT_1,
                                body: 'Have a nice day.',
                                ts: 1639660443
                            }],
                        unreads: 3
                    }, {
                        id: 9876543210,
                        caseId: 'XYZ-6789',
                        agent: AGENT_1,
                        items: [{
                                id: 1093847503984739,
                                type: ConversationItemTypeEnum.MESSAGE,
                                status: ConversationStatusType.OPEN,
                                authorType: AuthorType.AGENT,
                                author: AGENT_1,
                                body: 'Thank you for your time to help me out',
                                ts: 1639660443
                            }],
                        unreads: 1
                    }
                ]
            }
        }
    },
    /** fetch conversation with id 1234567890 */
    {
        url: '/conversations/1234567890',
        status: 200,
        data: {
            data: {
                id: 1234567890,
                caseId: 'ABC-12345',
                agent: AGENT_2,
                status: ConversationStatusType.OPEN,
                items: [
                    {
                        id: 7023879297384393,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.CUSTOMER,
                        author: CUSTOMER,
                        body: 'Thank you, *great messenger* this is (_italic_)',
                        status: MessageOutboundState.SENT,
                        ts: 1639659090
                    },
                    // {
                    //     id: null,
                    //     type: ConversationItemTypeEnum.INPUT,
                    //     fieldType: ConversationInputFieldType.EMAIL,
                    //     fieldName: 'email',
                    //     authorType: AuthorType.SYSTEM,
                    //     author: BOT,
                    //     // body: null,
                    //     body: 'hans@frits.com',
                    //     ts: 1639659092
                    // },
                    {
                        id: 0,
                        type: ConversationItemTypeEnum.FORM,
                        options: {
                            form: {
                                apiEndpoint: API.FORM,
                                type: FormTypes.PRECHAT,
                                borderedFields: true,
                                elements: [
                                    // {
                                    //     type: ElementType.SELECT,
                                    //     dataType: ElementDataType.TEXT,
                                    //     name: 'contact_id',
                                    //     minLength: 0,
                                    //     options: [{ value: true, text: 'yes boy'}, { value: false, text: 'no...'}],
                                    //     maxLength: 64,
                                    //     required: false,
                                    // },
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.TEXT,
                                        name: '_CONTACT_NAME',
                                        minLength: 0,
                                        maxLength: 64,
                                        required: false,
                                    },
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.TEXT,
                                        name: 'contact_id',
                                        minLength: 3,
                                        maxLength: 8,
                                        label: 'Contact ID',
                                        placeholder: '(PS-XXXXX)',
                                        defaultValue: 'PS-',
                                        required: true,
                                    },
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.EMAIL,
                                        name: '_CONTACT_EMAIL',
                                        minLength: 3,
                                        required: true,
                                    },
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.PHONE,
                                        name: '_CONTACT_PHONE',
                                        minLength: 3,
                                        maxLength: 32,
                                        required: true,
                                    },
                                    {
                                        type: ElementType.TEXTAREA,
                                        dataType: ElementDataType.TEXT,
                                        name: '_INITIAL_MESSAGE',
                                        minLength: 1,
                                        maxLength: 500,
                                        required: false,
                                    },
                                    {
                                        type: ElementType.SUBMIT_MESSAGE_SLOT
                                    },
                                    {
                                        type: ElementType.SUBMIT,
                                    }
                                ]
                            }
                        }
                    },
                    {
                        id: 8534983092123893,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.AGENT,
                        author: AGENT_1,
                        body: 'Have a nice day.',
                        status: MessageInboundState.RECEIVED,
                        ts: 1639660443
                    },
                    // {
                    //     id: 1093847503984747,
                    //     type: ConversationItemTypeEnum.CHAT_CLOSED,
                    //     authorType: AuthorType.SYSTEM,
                    //     author: SYSTEM,
                    //     body: 'Chat closed',
                    //     ts: 1639660489
                    // }
                ]
            }
        }
    },
    /** fetch conversation with id 9876543210 */
    {
        url: '/conversations/9876543210',
        status: 200,
        data: {
            data: {
                id: 9876543210,
                caseId: 'XYZ-6789',
                status: ConversationStatusType.OPEN,
                agent: AGENT_1,
                items: [
                    {
                        id: 1093847503984739,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.AGENT,
                        author: AGENT_1,
                        body: 'Thank you for your time to help me out',
                        ts: 1639660443
                    },
                    {
                        id: 1093847503984740,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.AGENT,
                        author: AGENT_1,
                        media: [{
                                content: {
                                    url: "https://www.ema.europa.eu/sites/default/files/amsterdam.jpg",
                                    mimeType: "image/jpeg",
                                    type: ConversationMediaType.IMAGE,
                                },
                                caption: "beautiful amsterdam",
                            }],
                        body: null,
                        ts: 1639660444
                    },
                    {
                        id: 1093847503984741,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.BOT,
                        author: AGENT_1,
                        media: [{
                                content: {
                                    url: "http://techslides.com/demos/sample-videos/small.mp4",
                                    mimeType: "video/mp4",
                                    type: ConversationMediaType.VIDEO
                                },
                                caption: "lego crap",
                            }],
                        body: null,
                        replyOptions: [
                            {
                                label: "Yes",
                                value: "1"
                            },
                            {
                                label: "No",
                                value: "2"
                            },
                            {
                                label: "Maybe",
                                value: "3"
                            }
                        ],
                        ts: 1639660446
                    }
                ]
            }
        }
    },
    /** fetch conversation with id 9876543219 which is archived (closed) */
    {
        url: '/conversations/9876543219',
        status: 200,
        data: {
            data: {
                id: 9876543219,
                caseId: 'XYZ-9999',
                status: ConversationStatusType.CLOSED,
                agent: AGENT_1,
                items: [
                    {
                        id: 1093847503984739,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.AGENT,
                        author: AGENT_1,
                        body: 'Thank you for your time to help me out',
                        ts: 1639660443
                    },
                    {
                        id: 1093847503984740,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.AGENT,
                        author: AGENT_1,
                        media: [{
                                content: {
                                    url: "https://www.ema.europa.eu/sites/default/files/amsterdam.jpg",
                                    mimeType: "image/jpeg",
                                    type: ConversationMediaType.IMAGE,
                                },
                                caption: "beautiful amsterdam",
                            }],
                        body: null,
                        ts: 1639660444
                    }
                ]
            }
        }
    },
    /** get conversation excerpts to view them in the home screen (last message only) */
    {
        url: '/conversations/archived',
        status: 200,
        data: {
            data: {
                conversations: [
                    {
                        id: 9876543219,
                        caseId: 'XYZ-9999',
                        agent: AGENT_2,
                        items: [{
                                id: 8534983092123899,
                                type: ConversationItemTypeEnum.MESSAGE,
                                status: ConversationStatusType.OPEN,
                                authorType: AuthorType.AGENT,
                                author: AGENT_1,
                                body: 'This old conversation is here!',
                                ts: 1639660443
                            }]
                    }
                ]
            }
        }
    },
    /** customer is online 1234567890 */
    {
        url: '/conversations/online',
        status: 200,
        data: {
            data: {}
        }
    },
    /** start new conversation */
    {
        url: '/conversations/add',
        status: 200,
        data: {
            data: {
                id: 5678901234,
                caseId: 'NEW-830812',
                agent: null,
                items: [
                    {
                        id: 8534983092123893,
                        type: ConversationItemTypeEnum.MESSAGE,
                        authorType: AuthorType.BOT,
                        author: BOT,
                        body: 'Thank you for starting a chat.',
                        ts: 1639660443
                    },
                    {
                        id: 0,
                        type: ConversationItemTypeEnum.FORM,
                        options: {
                            form: {
                                apiEndpoint: API.FORM,
                                type: FormTypes.PRECHAT,
                                borderedFields: true,
                                elements: [
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.TEXT,
                                        name: 'NAME',
                                        minLength: 0,
                                        maxLength: 64,
                                        required: false,
                                    },
                                    {
                                        type: ElementType.INPUT_TEXT,
                                        dataType: ElementDataType.EMAIL,
                                        name: 'EMAIL',
                                        minLength: 3,
                                        maxLength: 32,
                                        required: true,
                                    },
                                    {
                                        type: ElementType.SUBMIT_MESSAGE_SLOT
                                    },
                                    {
                                        type: ElementType.SUBMIT,
                                    }
                                ]
                            }
                        }
                    },
                ]
            }
        }
    },
    /** get contextual articles */
    {
        url: '/articles',
        status: 200,
        data: {
            data: {
                articles: [
                    {
                        id: 19302,
                        title: 'Grasp\'s rebranding',
                        author: AGENT_2,
                        updated: 1639660444,
                        excerpt: 'New websietr'
                    }
                ]
            }
        }
    },
    /** prechat form submitted */
    {
        url: '/forms',
        status: 200,
        data: {
            data: {}
        }
    },
    /** is typing 1234567890 */
    {
        url: '/conversations/1234567890/typing',
        status: 200,
        data: {
            data: {}
        }
    },
    /** send reply to conversation 1234567890 */
    {
        url: '/conversations/1234567890/message',
        status: 200,
        data: {
            data: {
                newMsgId: 17419203847
            }
        }
    },
    /** is typing 9876543210 */
    {
        url: '/conversations/9876543210/typing',
        status: 200,
        data: {
            data: {}
        }
    },
    /** send reply to conversation 9876543210 */
    {
        url: '/conversations/9876543210/message',
        status: 200,
        data: {
            data: {
                newMsgId: 17419203400
            }
        }
    },
    /** rate conversation */
    {
        url: '/conversations/1234567890/rate',
        status: 200,
        data: {
            data: {}
        }
    },
    /** update user info field (email) */
    {
        url: '/user/update',
        status: 200,
        data: {
            data: {}
        }
    },
    /** fetch article */
    {
        url: '/article/19302',
        status: 200,
        data: {
            data: {
                id: 19302,
                title: 'Grasp\'s rebranding',
                author: AGENT_2,
                updated: 1639660444,
                content: '<p>We are getting our notebooks out to count all of our conversations.</p><img src="https://www.globalgap.org/export/sites/default/.content/.galleries/Pictures/GRASP/Zeichenflaeche-4.jpg_123749786.jpg"/><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in rhoncus justo. Maecenas mattis, ante ut sodales molestie, nunc quam pretium turpis, eget facilisis ipsum diam ut urna. Aliquam erat volutpat. Proin lacinia erat quis libero suscipit, in placerat ipsum congue. Nam porttitor eros in ante tristique, aliquet interdum ipsum mattis. Nullam ex dui, sodales vel purus in, vehicula maximus sapien. Suspendisse eget erat ac erat imperdiet sagittis. Fusce sollicitudin urna lectus. Integer nec blandit urna. Donec eget blandit purus. Maecenas euismod felis vitae elementum commodo. Mauris sit amet est et risus iaculis ornare in in sapien. Nulla ut nisi ac neque egestas eleifend. Ut mollis semper aliquet. Vestibulum mi ex, laoreet ac convallis in, rhoncus in nunc. Phasellus eu nisl leo. Pellentesque maximus commodo gravida. Nam consequat elit a porttitor lacinia. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Praesent vel turpis diam. Phasellus magna lacus, imperdiet in bibendum at, dignissim non turpis. Vivamus pellentesque lectus et libero bibendum tristique. Curabitur a dolor at mi placerat aliquet. Vivamus malesuada ex vel diam varius, eu molestie nibh bibendum. Maecenas vel pellentesque risus. Nullam ac eleifend lorem. Maecenas maximus quam sit amet lacus ornare placerat. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed efficitur eu nunc at vestibulum. Morbi aliquet leo elit, laoreet pharetra libero volutpat lacinia. Cras vitae sodales lorem, et rhoncus sem.</p>'
            }
        }
    },
    /** send email */
    {
        url: API.CONTACT_MAIL_FORM,
        status: 200,
        data: {
        // message: 'It works email!'
        }
    },
    /** whatsapp contact form */
    {
        url: API.CONTACT_WHATSAPP_FORM,
        status: 200,
        data: {
        // message: 'It works whatsapp!'
        }
    },
    /** search */
    {
        url: '/article/search',
        status: 200,
        data: {
            data: {
                items: [
                    {
                        id: 19302,
                        title: 'Rebranding Grasp',
                        updated: 1637942121,
                        excerpt: 'We are getting our notebooks out to count all of our conversations'
                    },
                    {
                        id: 95439832,
                        title: 'Personalizing site messenger',
                        updated: 1639262184,
                        excerpt: 'The site messenger allows you to custom the look and feel to your own liking. Not only the primary color can be changed, but the welcome text as well.'
                    },
                    {
                        id: 95439833,
                        title: 'Controlling site messenger externally',
                        updated: 1637642810,
                        excerpt: 'To control the site messenger, an API is accessible through javascript to manipulate the behavior'
                    }
                ]
            }
        }
    }
];
